import { addHours, format } from 'date-fns';
import React, { useEffect, useMemo, useRef } from 'react';
import { WCS } from '../../week-utils';

interface GridTimeProps {
  startHour: Date;
  setHourY?: (y: number) => void;
  range: number;
}

const GridTime: React.FunctionComponent<GridTimeProps> = ({ startHour, range, setHourY }) => {
  const ref = useRef<HTMLSpanElement | null>(null);

  const displayedHour = useMemo(() => {
    return format(addHours(startHour, range), 'HH:00');
  }, []);

  useEffect(() => {
    if (range === WCS.defaultHour && setHourY && ref.current) {
      setHourY(ref.current.getBoundingClientRect().y);
    }
  }, [ref]);

  return (
    <span className="time" ref={ref}>
      <div className="time-display">{displayedHour}</div>
    </span>
  );
};

export default React.memo(GridTime);
